export enum SubscriptionType {
  MOBILE = 'MOBILE',
  VPOS = 'VPOS',
  CANCELLED = 'CANCELLED',
}
